import { atom, selector, useRecoilTransaction_UNSTABLE } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({ key: 'auth' });

export type AuthState = {
  username?: string;
  jwtToken?: string;
  source?: string;
  sourceId?: string;
  roleId?: string;
  partnerId?: string;
  userId?: string;
  isAdmin?: string;
};

const initialState: AuthState = {
  username: undefined,
  jwtToken: undefined,
  source: undefined,
  sourceId: undefined,
  roleId: undefined,
};

export const userIdState = atom<AuthState['username']>({
  key: 'username',
  default: initialState.username,
});

export const tokenState = atom<AuthState['jwtToken']>({
  key: 'jwtToken',
  default: initialState.jwtToken,
  effects: [persistAtom],
});

export const sourceState = atom<AuthState['source']>({
  key: 'source',
  default: initialState.source,
});

export const sourceIdState = atom<AuthState['sourceId']>({
  key: 'sourceId',
  default: initialState.sourceId,
});

export const roleIdState = atom<AuthState['roleId']>({
  key: 'roleId',
  default: initialState.roleId,
});

export const partnerIdState = atom<AuthState['partnerId']>({
  key: 'partnerId',
  default: initialState.partnerId,
});

export const useridState = atom<AuthState['userId']>({
  key: 'userId',
  default: initialState.userId,
});

export const isAdminState = atom<AuthState['isAdmin']>({
  key: 'isAdmin',
  default: initialState.isAdmin,
});
export const isLoggedInSelector = selector({
  key: 'isLoggedIn',
  get: ({ get }) => !!(get(tokenState) && get(userIdState)),
});

export const useSetAuthState = () =>
  useRecoilTransaction_UNSTABLE(({ set }) => (state: Required<AuthState>) => {
    set(userIdState, state.username);
    set(tokenState, state.jwtToken);
    set(sourceState, state.source);
    set(sourceIdState, state.sourceId);
    set(roleIdState, state.roleId);
    set(partnerIdState, state.partnerId);
    set(useridState, state.userId);
    set(isAdminState, state.isAdmin);
    sessionStorage.setItem('user', state.username);
    sessionStorage.setItem('token', state.jwtToken);
    sessionStorage.setItem('source', state.source);
    sessionStorage.setItem('sourceId', state.sourceId);
    sessionStorage.setItem('roleId', state.roleId);
    sessionStorage.setItem('partnerId', state.partnerId);
    sessionStorage.setItem('userId', state.userId);
    sessionStorage.setItem('isAdmin', state.isAdmin);
  });

export const useResetAuthState = () =>
  useRecoilTransaction_UNSTABLE(({ set }) => () => {
    set(userIdState, initialState.username);
    set(tokenState, initialState.jwtToken);
    set(sourceState, initialState.source);
    set(sourceIdState, initialState.sourceId);
    set(roleIdState, initialState.roleId);
    set(partnerIdState, initialState.partnerId);
    set(useridState, initialState.userId);
    set(isAdminState, initialState.isAdmin);
    // sessionStorage.clear();
  });
